
import { defineComponent } from 'vue'
import DigitalAssetUpload from '../../components/DigitalAssetUpload.vue'

export default defineComponent({
    data() {
        return {
            signageItemLayoutData: {} as any
        }
    },
    
    props: {
        layoutDataEdit: {
            type: Object,
            default: null
        },
        layoutType: {
            type: String,
            default: ''
        },
        signageAssets: {
            type: Object,
            default: null
        },
    },

    components: {
        DigitalAssetUpload
    },

    computed: {
        assetUrl() {
            if (this.signageAssets && this.signageAssets.length) {
                const signageAsset = this.signageAssets.find((sa: any) => sa.id == this.signageItemLayoutData.media.asset1);
                if (signageAsset) {
                    // FLOCK-6612: prefer the full-size asset file; the thumb is
                    // a ~200px derivative that renders soft in the upload box.
                    // Videos keep the thumb, a poster frame an <img> can show.
                    if (signageAsset.assetType !== 'video' && signageAsset.assetFiles && signageAsset.assetFiles.length && signageAsset.assetFiles[0].url) {
                        return signageAsset.assetFiles[0].url;
                    }
                    if (signageAsset.thumbUrl) {
                        return signageAsset.thumbUrl;
                    }
                }
                return null;
            }
            return null;
        }
    },

    created () {
        this.signageItemLayoutData = JSON.parse(JSON.stringify(this.layoutDataEdit));
    },

    watch: {
        'signageItemLayoutData': {
            handler(newValue: any){
                this.$emit('updateLayoutData', {updatedLayoutData: newValue, shouldUpdatePreview: true});
            },
            deep: true
        },
    }
})
